import AnalyticsEvent from './AnalyticsEvent';

class SVODStatus extends AnalyticsEvent {
	constructor(userInput, userId, device, isLocalAnalyticsEvent, isGoogleAnalyticsVisit, isGoogleAnalyticsEvent) {
		super(userInput, userId, device, isLocalAnalyticsEvent, isGoogleAnalyticsVisit, isGoogleAnalyticsEvent);
		this.className = "SVODEvent";
		this.dbDest = 'svod_status';

		this._label = null;
		this._timecode = -1;
		this._error = '';
		this._type = '';
		this._state = '';
		this._data = '';
	}

	appendBaseParams(uId, d) {
		this.append(uId, d);
	}
}

Object.defineProperty(SVODStatus.prototype, "gaEventSet", {
	get: function () {
		var urlComps = this.simulatedURL.split('_');

		this._gaEventSet.category = urlComps[0];
		this._gaEventSet.action = urlComps[1];
		this._gaEventSet.label = urlComps[2];
		urlComps.length > 3 ? this._gaEventSet.value = urlComps[4] : null;
		return this._gaEventSet;
	}
});


Object.defineProperty(SVODStatus.prototype, 'type', {
	set: function (tcode) {
		this._type = tcode;
		this.simulatedURL = this.simulatedURL.replace('[type]', this._type);
	},
	get: function () { return this._type; }
});

Object.defineProperty(SVODStatus.prototype, 'state', {
	set: function (tcode) {
		this._state = tcode;
		this.simulatedURL = this.simulatedURL.replace('[state]', this._state);
	},
	get: function () { return this._state; }
});


Object.defineProperty(SVODStatus.prototype, "label", {
	set: function (label) {
		this._label = label;
		this.simulatedURL = this.simulatedURL.replace('[label]', this._label);
	},
	get: function () { return this._label; }
});



Object.defineProperty(SVODStatus.prototype, 'timecode', {
	set: function (tcode) {
		this._timecode = tcode;
		this.simulatedURL = this.simulatedURL.replace('[time]', this._timecode);
	},
	get: function () { return this._timecode; }
});

Object.defineProperty(SVODStatus.prototype, "error", {
	set: function (error) {
		this._error = error;


		this.simulatedURL = this.simulatedURL.replace('[error]', this._error);
	},
	get: function () { return this._error; }
});


export default SVODStatus;


// WEBPACK FOOTER //
// ./src/analytics/analytics-events/SVODStatus.js